/**
 * The one way a component sends an utterance.
 *
 * A board card's button (a removal, a plan operation, a suggested reply) is the
 * VISITOR's next message — it is not a command to the frontend. So there is one
 * sender, wired once by `App`, and every caller hands it a string it does not
 * touch: a chip value is read by the lexical router, by the consent belts and by
 * the reverse parsers, and rewriting one here would break it silently
 * (docs/graphs/peterhof_guide.md, "Visitor-voice text (chip values) is load-bearing").
 */

/** `false` — the sender did not take the message (offline, another thread, nothing to say); any other
 *  answer, or none, took it. */
type Sender = (text: string) => unknown;

let sender: Sender | null = null;

export function wireSender(fn: Sender): void {
  sender = fn;
}

/**
 * Hands *text* to the wired sender. → whether it was TAKEN: a caller that shows «Убираю…» for a press
 * (`PlanTimeline`'s ✕) must not show it for a message that went nowhere.
 */
export function send(text: string): boolean {
  if (!sender) {
    // eslint-disable-next-line no-console
    console.warn('[send] no sender wired yet; dropped:', text);
    return false;
  }
  return sender(text) !== false;
}
